import WhatsAppIcon from '../../../assets/images/landing-page/whatsApp.png';

export default function WhatsApp() {
  const WHATSAPP_NUMBER = '573204088142'; // +57 320 408 8142

  const openWhatsApp = () => {
    const url = `https://wa.me/${WHATSAPP_NUMBER}`;
    window.open(url, '_blank');
  };

  return (
    <div className="absolute bottom-100 sm:bottom-120 md:bottom-76 lg:bottom-60 right-9 sm:right-20">
      <img
        src={WhatsAppIcon}
        alt="WhatsApp Icon"
        onClick={openWhatsApp}
        className="w-16 h-16 sm:w-20 sm:h-20 lg:w-25.5 lg:h-25.5 object-cover cursor-pointer"
      />
    </div>
  );
}
